// Module
var code = "<vdc-tiers></vdc-tiers>\n";
// Exports
module.exports = code;